import { ShieldCheck } from 'lucide-react';

export function PrivacyNotice() {
  return (
    <section id="politika-privatnosti" className="scroll-mt-28 border-t border-border bg-background py-10">
      <div className="site-container">
        <div className="flex max-w-3xl items-start gap-4">
          <ShieldCheck aria-hidden="true" className="mt-0.5 size-5 shrink-0 text-text-muted" />
          <div>
            <h2 className="font-semibold text-text-primary">Napomena o privatnosti</h2>
            <p className="mt-2 text-sm leading-6 text-text-secondary">
              Podaci iz forme koriste se isključivo za odgovor na poslati upit. Ovaj tekst je pripremljena osnova i treba ga uskladiti sa finalnom politikom privatnosti firme pre objave sajta.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
